module.exports = __webpack_public_path__ + "static/media/arrow-right-long.fb55eef7.svg";